import React from 'react';

import range from 'lodash/range';

import { GenericEntityBlockSkeleton } from '@lumapps/lumx-blocks/components/GenericEntityBlockSkeleton';
import { ListItem } from '@lumapps/lumx/react';

/** Skeleton made of item with GenericEntityBlockSkeleton inside. */
export const EventBlockSkeletons = range(3).map((i) => (
    <ListItem key={i}>
        <GenericEntityBlockSkeleton hasImage hasMetadata hasAdditionalInformation />
    </ListItem>
));
